import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../common/helpers/helpers";
import Expander from "../../../../components/Expander";

const getMouseTable = (item) => {
  const mouseTableBody = item.map((tm, i) => {
    const tableRow = (
      <tr key={i}>
        <td>{tm}</td>
      </tr>
    );
    return tableRow;
  });
  const table = (
    <table className="varsome-table">
      <thead>
        <tr>
          <th>Phenotypes</th>
        </tr>
      </thead>
      <Expander showMore="5" component="tbody">
        {mouseTableBody}
      </Expander>
    </table>
  );

  return table;
};

const MouseResult = ({ mousePhenotype, mouseGene }) => {
  if (mousePhenotype && mouseGene) {
    const mouseResult = (
      <div className="tw-mt-7">
        <h5>
          <a
            href={getVarsoUrl("http://www.informatics.jax.org/")}
            target="_blank"
          >
            MGI - Mouse Genome Informatics
          </a>
        </h5>
        {mouseGene && (
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="varsome-horiz-list-item">
                    <div className="varsome-horiz-list-label">Gene</div>
                    <div className="varsome-horiz-list-value">{mouseGene}</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        )}
        {getMouseTable(mousePhenotype)}
      </div>
    );
    return mouseResult;
  }
  return null;
};

const { string, arrayOf } = PropTypes;

MouseResult.propTypes = {
  mouseGene: string,
  mousePhenotype: arrayOf(string),
};

MouseResult.defaultProps = {
  mouseGene: null,
  mousePhenotype: null,
};
export default MouseResult;
